angular
    .module('festzelt-os.modules.bo')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.bo', {
            abstract: true,
            url: '/bo/',
            template: '<ui-view/>',
            data: {
                pageTitle: 'Bookable Objects',
                showBackBtn: true
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/bo-routes.js